import { NavLink } from "react-router-dom";
import "./inner-page-navigation.scss";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { useMemo } from "react";

export default function LocationNavigation(props: any) {
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = useMemo(() => urlParamsFun(), [
    window.location.href,
  ]);
  return (
    <div className="common-sticky-subheader">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid  d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <NavLink to={`/configuration/locations?${mainQueryRequest}`} className="">
              <img
                src="/images/back-link.svg"
                className="img-fluid"
                height={24}
                width={24}
              />
            </NavLink>
            <div className="inner-page-navigation-with-back-cta-button__header">
              <h4 className="inner-page-navigation-with-back-cta-button__header-title">
                Locations
              </h4>
            </div>
          </div>
          <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
            {!props.id && (
              <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                <NavLink
                  to={`/location/detail?${mainQueryRequest}`}
                  className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                >
                  Location
                </NavLink>
              </li>
            )}
            {props.id && props.id !== "undefined" && (
              <>
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/detail/${props.id}?${mainQueryRequest}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Location
                  </NavLink>
                </li>
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/map-vendor/${props.id}?${mainQueryRequest}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Map To Vendors
                  </NavLink>
                </li>
                {/* <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/functions/${props.id}?${mainQueryRequest}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Function
                  </NavLink>
                </li> */}
              </>
            )}
          </ul>
          <div>
            {/* <button className="ascent-button ascent-button--header-buttons ascent-button--secondary mx-3">
							Edit
						</button> */}
            <button className="ascent-button ascent-button--visibility ascent-button--header-buttons ascent-button--primary">
              Save
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
